import React from 'react';
import type { Nullable } from 'corgi-types';

import type { PrismicImage } from 'common/components/PrismicResponsiveImage';
import { usePromoEvents } from 'common/hooks/dynamic-yield';
import type { CampaignTrackingData } from 'common/tracking/campaignEventData';
import type { BaseBannerProps } from 'common/types/Banner';
import TopImageBanner from './TopImageBanner';
import TopTextBanner from './TopTextBanner';

export interface TopBannerProps extends BaseBannerProps, CampaignTrackingData {
  image?: Nullable<PrismicImage>;
}

const TopBanner = ({
  name,
  placement,
  dyDecisionId,
  dyVariationId,
  image,
  ...props
}: TopBannerProps) => {
  const { onPromoView, onPromoClick } = usePromoEvents({
    dyDecisionId,
    dyVariationId,
    placement,
    name,
  });

  return (
    <div data-corgi-id="top-banner">
      {image ? (
        <TopImageBanner
          onPromoView={onPromoView}
          onPromoClick={onPromoClick}
          image={image}
          {...props}
        />
      ) : (
        <TopTextBanner onPromoView={onPromoView} onPromoClick={onPromoClick} {...props} />
      )}
    </div>
  );
};

export default TopBanner;
